import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  FormLabel,
  IconButton,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "../../components/ui";
import { Add, Delete, Edit, Search } from "../../components/icons";
import { toast } from "react-toastify";
import axiosInstance from "../../axios/axiosInstance";
import { modalStyle } from "../../style/common";
import AppartmentForm from "./components/AppartmentForm";
const ApartmentType = [
  { label: "Residence", value: "residence" },
  { label: "Company", value: "company" },
  { label: "Club", value: "club" },
  { label: "All", value: "all" },
];
const Appartment = () => {
  const role: any = localStorage.getItem("role");
  const [open, setOpen] = useState<boolean>(false);
  const [appartment, setAppartment] = useState<any>([]);
  const [id, setId] = useState<any>(null);
  const [filter, setFilter] = useState<any>("all");

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setId(null);
    handleGetAppartment();
  };

  const handleGetAppartment = async () => {
    try {
      const resp: any = await axiosInstance.get(
        `/api/appartment?searchQuery=${filter == "all" ? "" : filter}`
      );
      if (resp?.status === 200) {
        setAppartment(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      const resp: any = await axiosInstance.delete(
        `/api/appartment/${id}?invocation=${role}`
      );
      if (resp?.status === 200) {
        if (Number(role)) {
          toast.success("Add apartment request sent to Super Admin");
        } else {
          toast.success("Apartment deleted successfully");
        }
        handleGetAppartment();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body);
    }
  };

  useEffect(() => {
    handleGetAppartment();
  }, [filter]);

  return (
    <div>
      <Grid container p={2} px={{ md: 10, xs: 5 }}>
        <Grid size={12}>
          <Button onClick={handleOpen} sx={{ textTransform: "none" }}>
            <Typography fontSize={20} fontWeight={500} color="#111827">
              Apartments
              <IconButton onClick={handleOpen}>
                <Add sx={{ color: "#111827" }} />
              </IconButton>
            </Typography>
          </Button>
        </Grid>
        <Grid size={12} display={"flex"} justifyContent={"end"} container>
          <Grid size={11} pr={1}>
            <TextField
              size="small"
              id="outlined-basic"
              placeholder="Search Visitors..."
              onChange={(e: any) => setFilter(e?.target?.value)}
              slotProps={{
                input: {
                  endAdornment: <Search sx={{ color: "#111827" }} />,
                },
              }}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid size={1}>
            <Box>
              <Select
                sx={{ minWidth: "100px" }}
                variant="outlined"
                label="type"
                size="small"
                value={filter}
                onChange={(e: any) => setFilter(e?.target?.value)}
              >
                {ApartmentType.map((item: any) => (
                  <MenuItem key={item?.value} value={item?.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Grid>
          {/* <FormLabel> Apartment Type</FormLabel> */}
        </Grid>
        <Grid
          size={12}
          container
          mt={2}
          py={1}
          bgcolor={"#111827"}
          borderRadius={1}
          color={"whitesmoke"}
        >
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Sl no
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Apartment No
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Apartment Name
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Apartment Type
            </Typography>
          </Grid>
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Floor
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Block
            </Typography>
          </Grid>
          <Grid size={1}>
            <Typography fontSize={17} fontWeight={500} align="center">
              Action
            </Typography>
          </Grid>
        </Grid>

        {appartment?.map((item: any, index: any) => (
          <Grid size={12} container borderBottom={"1px solid #111827"} py={2}>
            <Grid size={1}>
              <Typography fontSize={17} align="center">
                {index + 1}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} align="center">
                {item?.appartment_no}
              </Typography>
            </Grid>
            <Grid size={3}>
              <Typography fontSize={17} align="center">
                {item?.appartment_name}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} align="center">
                {item?.apartment_type}
              </Typography>
            </Grid>
            <Grid size={1}>
              <Typography fontSize={17} align="center">
                {item?.floor}
              </Typography>
            </Grid>
            <Grid size={2}>
              <Typography fontSize={17} align="center">
                {item?.block?.block_name}
              </Typography>
            </Grid>

            <Grid
              size={1}
              sx={
                item?.is_request_send && {
                  pointerEvents: "none",
                  opacity: 0.6,
                }
              }
            >
              <Typography fontSize={17} align="center">
                <IconButton
                  onClick={() => {
                    setId(item?.id);
                    handleOpen();
                  }}
                >
                  <Edit sx={{ color: "#111827" }} />
                </IconButton>
                <IconButton onClick={() => handleDelete(item?.id)}>
                  <Delete sx={{ color: "#111827" }} />
                </IconButton>
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
      <Modal onClose={handleClose} open={open}>
        <Box sx={modalStyle}>
          <AppartmentForm onClose={handleClose} id={id} />
        </Box>
      </Modal>
    </div>
  );
};

export default Appartment;
